function getYear(date) {
  const dateObj = new Date(date);
  if (dateObj && dateObj.getFullYear) {
    return dateObj.getFullYear();
  }
}
export {
  getYear
};
